import { Pipe, PipeTransform } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { map, takeUntil, takeWhile } from 'rxjs/operators';

@Pipe({
    name: 'countdown',
    pure: false
})
export class CountdownPipe implements PipeTransform {
    public timerObs;
    public value;
    public timerSubject  = new Subject();
    
    transform(endTime: string) {
        const endTimestamp = Date.parse(endTime);
        if (this.timerObs) {
            return this.value;
        }

        if (isNaN(endTimestamp)) {
            return 'Invalid time';
        } else {
            const nowTimestamp = Date.now();
            const timeRemaining = endTimestamp - nowTimestamp;
            let duration = timeRemaining < 0 ? 0 : timeRemaining;
            this.timerObs = timer(0, 1000).pipe(
                takeWhile(() => duration > 0),
                takeUntil(this.timerSubject),
                map(() => {
                    const hours = Math.floor(duration / (1000 * 60 * 60));
                    const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((duration % (1000 * 60)) / 1000);
                    duration -= 1000;
                    return `${this.padNumber(hours)}:${this.padNumber(minutes)}:${this.padNumber(seconds)}`;
                })
            ).subscribe((v) => {
                this.value = v;
            });
         
            if (duration <= 0) {
                setTimeout(() => {
                    this.value = 'Finished';
                },100)
                return
            }
        }
    }
    
    private padNumber(number: number): string {
        return number < 10 ? `0${number}` : `${number}`;
    }
    
    ngOnDestroy() {
        this.timerSubject.next(true);
        this.timerSubject.complete();
    }
}
